exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cap-it-ui-alert-bar .notification-area-container{bottom:0;left:0;position:fixed;width:100%}.cap-it-ui-alert-bar .notification-area-container .hidden{display:none}.cap-it-ui-alert-bar .notification-area-container .alert-bar-base-content{overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/alert-bar/styles/notification-area-container.scss
// module id = 5233
// module chunks = 0